import { openWebBrowser } from '@utils/openWebBrowser'
import { documentDirectory, downloadAsync } from 'expo-file-system/legacy'
import { shareAsync } from 'expo-sharing'
import { useCallback, useState } from 'react'
import { useToastController } from '@tamagui/toast'
import { isWeb } from 'tamagui'

interface IUseContentDownloadParams {
  /** Extensão usada só como fallback do nome do arquivo salvo no dispositivo. */
  fileExt?: string | null
}

/**
 * Download do arquivo de uma mídia. No web abre a URL (o browser resolve o
 * download/preview); no nativo baixa para o diretório do app e abre a folha de
 * compartilhamento, que é o caminho para o usuário salvar o arquivo.
 */
export function useContentDownload({
  fileExt,
}: IUseContentDownloadParams = {}) {
  const [isDownloading, setIsDownloading] = useState(false)
  const toast = useToastController()

  const download = useCallback(
    async (fileUrl?: string | null, shouldOpenInNewTab = true) => {
      if (!fileUrl) return

      if (isWeb) {
        openWebBrowser(fileUrl, shouldOpenInNewTab)
        return
      }

      try {
        setIsDownloading(true)

        const fileName = fileUrl.split('/').pop() || `file.${fileExt}`
        const localURL = `${documentDirectory}${fileName}`

        await downloadAsync(fileUrl, localURL)
        await shareAsync(localURL)
      } catch (error) {
        toast.show('Erro ao baixar arquivo!', {
          message:
            'Houve um erro ao baixar o arquivo. Por favor, tente novamente.',
          type: 'error',
        })
      } finally {
        setIsDownloading(false)
      }
    },
    [fileExt, toast],
  )

  return { download, isDownloading }
}
